import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OfferLink } from './OfferLink';
import { product, systemIntro } from '../data/salesCopy';
export function SystemIntro() {
  return <section className="bg-brand-sage px-4 py-8 text-brand-ivory sm:py-10" data-id="element-230" data-mp="23a6q2cps3j84">
      <div className="mx-auto max-w-4xl" data-id="element-231" data-mp="28886sqzqf6gf">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-brand-gold sm:text-xs" data-id="element-232" data-mp="28a2rq5b06yki">
          {systemIntro.eyebrow}
        </p>
        <h2 className="mt-2 text-center font-serif text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-233" data-mp="1fkcc1rtq3oma">
          {systemIntro.heading}
        </h2>

        <div className="mt-5 grid items-center gap-5 sm:grid-cols-[auto_1fr] sm:gap-7" data-id="element-234" data-mp="1ph7a69m33n01">
          <OfferLink className="block" data-id="element-235" data-mp="2vxjbuko47n0d">
            <img src={product.image} alt="YIN YOGA READY™ box set with six modules" className="mx-auto w-full max-w-[210px] drop-shadow-2xl transition-transform duration-200 ease-smooth hover:scale-[1.02]" data-id="element-236" data-mp="2vwhobgpwx81r" />
          </OfferLink>

          <div className="text-center sm:text-left" data-id="element-237" data-mp="11gsgqd8p1dw1">
            <p className="font-serif text-2xl font-extrabold uppercase leading-none text-white sm:text-3xl" data-id="element-238" data-mp="11ext2r61f7o9">
              🧘 {product.name}
            </p>
            <p className="mt-1 text-[11px] font-extrabold uppercase tracking-[0.18em] text-brand-sand sm:text-xs" data-id="element-239" data-mp="rht6iq8a5a6x">
              {product.tagline}
            </p>
            <p className="mt-1.5 text-[11px] font-semibold text-brand-ivory/80 sm:text-xs" data-id="element-240" data-mp="ht2xiuetolyf">
              {product.strip}
            </p>

            <ul className="mt-3 space-y-1" data-id="element-241" data-mp="dsiytmelpaa6">
              {systemIntro.nots.map(line => <li key={line} className="flex items-start justify-center gap-1.5 text-[12.5px] font-medium leading-snug text-brand-ivory/80 sm:justify-start sm:text-[13.5px]" data-id="element-242" data-mp="8tfuk46g3839">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-clay" aria-hidden="true" data-id="element-243" data-mp="3v0cyrsqykg1q" />
                  {line}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-5 rounded-lg border border-brand-gold/40 bg-brand-sageDark/60 p-4 text-center" data-id="element-244" data-mp="3cccatopkjnoq">
          <p className="text-[12.5px] font-semibold text-brand-ivory/85 sm:text-sm" data-id="element-245" data-mp="3gdnr33mjywk9">
            {systemIntro.bridge}
          </p>
          <p className="mt-1.5 font-serif text-base italic text-brand-clay sm:text-lg" data-id="element-246" data-mp="7z5o3gbgy77i">
            {systemIntro.from}
          </p>
          <p className="text-[11px] font-bold uppercase tracking-widest text-brand-ivory/60" data-id="element-247" data-mp="3vaevxsezx0h9">
            to
          </p>
          <p className="font-serif text-base font-extrabold text-brand-gold sm:text-xl" data-id="element-248" data-mp="35axdsxg4ryx">
            {systemIntro.to}
          </p>
        </div>

        <ul className="mt-5 grid gap-x-5 gap-y-1.5 sm:grid-cols-2" data-id="element-249" data-mp="qtu8eg7vriup">
          {systemIntro.checks.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-semibold leading-snug text-white sm:text-[13.5px]" data-id="element-250" data-mp="2gd2f70x5mv5a">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-251" data-mp="2bbwmv47ep9wa" />
              {item}
            </li>)}
        </ul>

        <div className="mx-auto mt-6 max-w-md" data-id="element-252" data-mp="2l5vidkcz5vf9">
          <CTAButton subLabel={`🛡️ ${product.guarantee}`} data-id="element-253" data-mp="1xdetoqyqf56z">
            🧘 YES! I WANT THE COMPLETE SYSTEM
          </CTAButton>
        </div>
      </div>
    </section>;
}